@file:OptIn(InternalResourceApi::class)

package myofficialwebsite_master.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/myofficialwebsite_master.composeapp.generated.resources/"

@delegate:ResourceContentHash(-640_072_835)
internal val Res.font.noto_sans_sc_vf: FontResource by lazy {
      FontResource("font:noto_sans_sc_vf", setOf(
        ResourceItem(setOf(), "${MD}font/noto_sans_sc_vf.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("noto_sans_sc_vf", Res.font.noto_sans_sc_vf)
}
